import { action, observable, reaction, makeObservable } from 'mobx';
import {logger} from '../../helpers';

const history = window.history;

class RouterStore {
  @observable
  path: string;

  constructor() {
    makeObservable(this);
    this.path = window.location.pathname;
    window.addEventListener('popstate', this.updatePathAfterTimeout);
  }

  private updatePathAfterTimeout = () => {
    setTimeout(this.updatePath);
  };

  @action
  private updatePath = () => {
    this.path = window.location.pathname;
  };

  @action
  navigateTo(url: string) {
    history.pushState({}, '', url);
    this.updatePathAfterTimeout();
  }

  @action
  redirectTo(url: string) {
    history.replaceState({}, '', url);
    this.updatePathAfterTimeout();
  }
}

export const routerStore = new RouterStore();
